// Leitura centralizada dos params do veículo da proposta (cadastrados no AdminWeb, resolvidos por Empresa → Portal → Padrão):
export default {
  controller: 'PropostaVeiculo',
  TiposPlaca (th) {
    return th.$param.PropostaVeiculo_TiposPlaca || th.$aux.TipoPlaca.map(p => p.value)
  },
  OpcoesTipoPlaca (th) {
    const tiposPlaca = this.TiposPlaca(th)
    return th.$aux.TipoPlaca.filter(p => tiposPlaca.includes(p.value))
  },
  Carencia (th, dadosVeiculo) {
    const config = th.$param.PropostaVeiculo_Carencia || {}
    const porTipo = (config.porTipo || []).filter(p => p.tipoPlaca === dadosVeiculo.TipoPlaca)
    const item = porTipo.find(p => p.tipoSegmento && p.tipoSegmento === dadosVeiculo.TipoSegmento) || porTipo.find(p => !p.tipoSegmento)
    const anos = item ? item.anos : config.padrao
    return anos || null
  },
  AnoBaseCarencia (th) {
    return (th.$param.PropostaVeiculo_Carencia || {}).anoBase || null
  },
  MarcaPadrao (th) {
    return th.$param.PropostaVeiculo_Marca || null
  }
}
